import { StyledContent } from '@/components/styles'
import Youtube from 'react-youtube'

const TitleContentVideo = ({ data }) => {
  const { content: htmlContent, video_id } = data

  return (
    <>
      {htmlContent && (
        <StyledContent.Description>
          <StyledContent.Html dangerouslySetInnerHTML={{ __html: htmlContent }} dark/>
        </StyledContent.Description>
      )}

      {video_id && (
        <StyledContent.Video>
          <Youtube videoId={video_id} />
        </StyledContent.Video>
      )}
    </>
  )
}

export default TitleContentVideo
